import { type FC } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { ChartNoAxesCombined, Users } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@capacit-com/lara-law-shared-ui";
import PageContent from "../PageContent";
import { cn } from "@/lib/utils";

const InsightsNavigationView: FC = () => {
  return (
    <PageContent
      title="Insights"
      customAppBarContent={
        <div className="shrink-0 sticky top-0 z-10 bg-background flex-1">
          <TooltipProvider>
            <nav className="flex gap-0 lg:gap-4 justify-start md:justify-between lg:justify-start border-b">
              <Tooltip>
                <TooltipTrigger>
                  <NavLink
                    to="/insights/conversations"
                    className={({ isActive }) =>
                      cn(
                        "flex items-center gap-2 px-2 lg:px-4 h-12",
                        isActive && "border-primary text-primary border-b-2"
                      )
                    }
                  >
                    <ChartNoAxesCombined className="size-6 md:w-4 md:h-4 mx-8 md:mx-0 shrink-0" />
                    <span className="hidden md:inline">Insights</span>
                  </NavLink>
                </TooltipTrigger>
                <TooltipContent className="md:hidden">Insights</TooltipContent>
              </Tooltip>
              <Tooltip>
                <TooltipTrigger>
                  <NavLink
                    to="/insights/users"
                    className={({ isActive }) =>
                      cn(
                        "flex items-center gap-2 px-2 lg:px-4 min-w-0 h-12",
                        isActive && "border-primary text-primary border-b-2"
                      )
                    }
                  >
                    <Users className="size-6 md:w-4 md:h-4 mx-8 md:mx-0 shrink-0" />
                    <span className="hidden md:inline truncate">
                      Bruger insights
                    </span>
                  </NavLink>
                </TooltipTrigger>
                <TooltipContent className="md:hidden">
                  Bruger insights
                </TooltipContent>
              </Tooltip>
            </nav>
          </TooltipProvider>
        </div>
      }
    >
      <div className="flex flex-col transition-all duration-300">
        <Outlet />
      </div>
    </PageContent>
  );
};

export default InsightsNavigationView;
